import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_BALANCE_ENERGY,
  SAVE_DT_BALANCE_ENERGY,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function Table(props) {
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "Dummy",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "2%",
      },
      formatter: CountIndexRow,
    },
  ]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }


  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (
      rowIndex == modelDeviceList.length - 1 &&
      dateNow == moment(props.dateSelected).format("YYYY-MM")
    ) {
      style.fontWeight = "bold";
      style.color = "#FFFFFF";
      style.border = "2px solid #FFFFFF";
      // style.opacity = "0.6";
    } else {
      style.color = "white";
    }

    return style;
  };

  const addHeaderTable = () => {
    $(`.balancingenergy-${props.shipper.CONTACT_CODE}-table-header`).remove();
    let thead = document
      .getElementById(`balancingenergy-${props.shipper.CONTACT_CODE}-table`)
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML = `<th class="balancingenergy-${props.shipper.CONTACT_CODE}-table-header" colspan="1" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px;width:40px" ,">Date</th>`;
    props.column.map(row => {
      tr.innerHTML += `<th class="balancingenergy-${props.shipper.CONTACT_CODE}-table-header" colspan="${props.zone.length}" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px">${row.BALANCECOLUMN_NAME}</th>`;
    });

    thead.prepend(tr);
  };

  const formatNumber = (cellContent, row) => {
    return <>{numberFormat(cellContent, 2)}</>;
  };

  const generateRow = () => {
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    function getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push({
          date: new Date(date),
          BALANCE_DATE: moment(new Date(date)).format("YYYY-MM-DD"),
          BALANCE_DAY: new Date(date).getDate(),
        });
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
    let currentDate = addDays(new Date(), -1);
    let startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    let dayList;
    let dateDiff = currentDate.getDate() - startDate.getDate() + 1;

    if (
      props.dateSelected &&
      (props.dateSelected.getFullYear() < currentDate.getFullYear() ||
        (props.dateSelected.getMonth() < currentDate.getMonth() &&
          props.dateSelected.getFullYear() == currentDate.getFullYear()))
    ) {
      dayList = getDaysInMonth(
        props.dateSelected.getMonth(),
        props.dateSelected.getFullYear()
      );
      // console.log(dayList)
    } else {
      dayList = getDaysInMonth(
        currentDate.getMonth(),
        currentDate.getFullYear()
      );
      dayList = dayList.slice(0, dateDiff);
    }
    // console.log(dayList)
    dayList = addFieldToModelDeviceList(dayList);
    // console.log(dayList)
    setModelDeviceList([...dayList]);
  };
  const renderColumn = () => {
    let addColumn = [
      ...props.column
        .sort((a, b) =>
          a.BALANCECOLUMN_ORDER > b.BALANCECOLUMN_ORDER
            ? 1
            : b.BALANCECOLUMN_ORDER > a.BALANCECOLUMN_ORDER
            ? -1
            : 0
        )
        .filter(
          obj =>
            obj.BALANCECOLUMN_SHOW == true || obj.BALANCECOLUMN_SHOW == "true"
        )
        .map(objColumn => {
          return props.zone
            .sort((a, b) =>
              a.BALANCEZONE_ORDER > b.BALANCEZONE_ORDER
                ? 1
                : b.BALANCEZONE_ORDER > a.BALANCEZONE_ORDER
                ? -1
                : 0
            )
            .map(objZone => ({
              dataField:
                objColumn.BALANCECOLUMN_NAME.replaceAll(".", "_") +
                "_" +
                objZone.BALANCEZONE_ALIAS.replaceAll(".", "_"),
              text: objZone.BALANCEZONE_ALIAS,
              headerAlign: "center",
              editable: false,
              formatter: formatNumber,
              align: "center",
              headerStyle: {
                backgroundColor: colorOption[2].label,
                fontSize: "10px",
                width: "20px",
              },
              style: { width: "20px" },
              classes: (cell, row, rowIndex, colIndex) => {
                let className = "";
                if (objColumn.STATUS_FLAG != 0) className += "from-source";
                if (objColumn.STATUS_FLAG == 1) className += " pmis";
                if (objColumn.STATUS_FLAG == 3) className += " gqms";
                return className;
              },
              // validator: (newValue, row, column, done) => {
              //   setTimeout(() => {
              //     if (isNaN(newValue)) {
              //       return done({
              //         valid: false,
              //         message: "Should be numeric",
              //       });
              //     }
              //     return done();
              //   }, 0);
              //   return {
              //     async: true,
              //   };
              // },
            }));
        }),
    ];
    let data = [];
    addColumn.map(array => {
      array.map(obj => data.push(obj));
    });
    // console.log(data)
    setColumnRenderList([
      {
        dataField: "Dummy",
        text: "",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          fontSize: "12px",
          width: "40px",
        },
        style: { width: "40px" },
        formatter: CountIndexRow,
      },
      ...data,
      //   {
      //     dataField: "Action",
      //     text: "Action",
      //     headerAlign: "center",
      //     editable: false,
      //     align: "center",
      //     headerStyle: {
      //       backgroundColor: "#556ee6",
      //       width: "10%"
      //     },
      //     style: { width: "10%" },
      //     isDummyField: true,
      //     formatter: ButtonAction,
      //   },
    ]);
  };

  //   useEffect(() => {
  //     //fixed header table
  //     let tableId = "balancing-tab-table";
  //     let scrollY = 195;
  //     function fixedTableHeader() {
  //       let headerTable = document.querySelector(`#${tableId} thead`);
  //       if (window.scrollY >= scrollY) {
  //         headerTable.classList.add("fixed-header");

  //         resizeTableHeader()
  //       } else {
  //         headerTable.classList.remove("fixed-header");
  //       }
  //     }
  //     function resizeTableHeader() {
  //       setTimeout(() => {
  //         let headerTable = document.querySelector(`#${tableId} thead`);
  //         let tr = document.querySelector(`#${tableId} tbody tr`);
  //         let th = headerTable.querySelector(".header-style");
  //         for (var i = 0; i < tr.childNodes.length; i++) {
  //           th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
  //         }
  //       }, 1);
  //     }
  //     window.addEventListener("scroll", fixedTableHeader);
  //     document.querySelector(`#vertical-menu-btn`).addEventListener("click", resizeTableHeader)
  //     return () => {
  //       window.removeEventListener("scroll", fixedTableHeader);
  //       document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
  //     };
  //     //fixed header table
  //   }, []);
  useEffect(() => {
    generateRow();
    // console.log(props.data)
  }, [props.data]);
  useEffect(() => {
    renderColumn();
    generateRow();
  }, [props.zone, props.column]);
  useEffect(() => {
    generateRow();
  }, [props.dateSelected]);
  useEffect(() => {
    addHeaderTable();
  }, [columnRenderList]);

  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      BALANCE_DATE: "",
      BALANCECOLUMN_PID: "",
      BALANCECOLUMN_ORDER: 0,
      BALANCECOLUMN_NAME: "",
      BALANCE_DAY: 0,
      BALANCE_DATA: 0,
      SOURCE_PID: null,
      SOURCE_NAME: null,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      let data = props.data;
      let modelList = [];
      // console.log(data)
      props.column.map(objColumn => {
        props.zone.map(objZone => {
          modelList = [
            ...rowList.map(obj => {
              let value = data.find(
                value =>
                  value.BALANCECOLUMN_PID == objColumn.PID &&
                  value.BALANCE_DAY == obj.BALANCE_DAY &&
                  value.BALANCEZONE_PID == objZone.PID
              );

              obj[
                objColumn.BALANCECOLUMN_NAME.replaceAll(".", "_") +
                  "_" +
                  objZone.BALANCEZONE_ALIAS.replaceAll(".", "_")
              ] = value ? value.BALANCE_DATA : 0;

              obj[
                `${objColumn.BALANCECOLUMN_NAME.replaceAll(".", "_")}__data`
              ] = {
                ...dataModel,
                ...value,
                BALANCE_DATE: obj.BALANCE_DATE,
                BALANCE_DAY: obj.BALANCE_DAY,
                BALANCECOLUMN_PID: objColumn.PID,
                BALANCECOLUMN_ORDER: objColumn.BALANCECOLUMN_ORDER,
                BALANCECOLUMN_NAME: objColumn.BALANCECOLUMN_NAME,
              };
              return { ...obj };
            }),
          ];
          // console.log(modelList)
        });
        // console.log(modelList)
      });
      // console.log(modelList)
      return modelList;
    }
  };
  const columnOption = {
    menu: (provided, state) => ({
      ...provided,
      width: 270,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#2E3446" : undefined,
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "#2A3042",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#BFC8E2",
      ":hover": {
        backgroundColor: "#2A3042",
        color: "white",
      },
    }),
  };

  return (
    <Col sm="12">
      <div className="d-flex justify-content-start">
        <h5> {props.shipper.SHIPPER_NAME}</h5>
      </div>
      <div className="mt-2">
        <BootstrapTable
          id={`balancingenergy-${props.shipper.CONTACT_CODE}-table`}
          keyField="date"
          data={modelDeviceList}
          columns={columnRenderList}
          rowStyle={rowStyle}
          headerClasses="header-style"
          // cellEdit={cellEditFactory({
          //   mode: "click",
          //   blurToSave: true,
          //   onStartEdit: (oldValue, newValue, row, column) => {
          //     $("#balancing-tab-table .form-control.editor.edit-text").bind(
          //       "enterKey",
          //       function (e) {
          //         let cell = $(this).parent().next();
          //         setTimeout(() => {
          //           cell.click();
          //         }, 50);
          //       }
          //     );
          //     $(
          //       "#balancing-tab-table .form-control.editor.edit-text"
          //     ).keypress(function (e) {
          //       if (e.keyCode == 13) {
          //         $(this).trigger("enterKey");
          //       }
          //     });
          //   },
          //   afterSaveCell: (oldValue, newValue, row, column) => {

          //   },
          // })}
        />
      </div>
      <hr />
    </Col>
  );
}

export default Table;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn

Table.propTypes = {
  dateSelected: PropTypes.any,
  column: PropTypes.any,
  zone: PropTypes.any,
  data: PropTypes.any,
  shipper: PropTypes.any,
};
